import React from 'react';
import { Grid, Row, Col } from 'react-flexbox-grid';
import { Form, Select, Button, Avatar, Radio, Divider, Input } from 'antd';

const { Option } = Select;

const FormNewPromotion = ({ newCategory, onSubmit, categoriesOfPromotions, isNewCategory, isSaving, onExit, isSavedPromotions, fileIcons }) => {

    const [form] = Form.useForm();

    const onReset = () => {
        form.resetFields();
    }

    const onExitForm = () => {
        onReset();
        onExit();
    }

    return (
        <Grid>
            <Form onFinish={onSubmit} form={form} initialValues={{
                field_icon: fileIcons && fileIcons[0].name
            }}>
                <Row center="xs">
                    <Col xs={10} sm={8} md={4}>
                        {
                            isNewCategory ?
                                <Form.Item name="field_category" rules={[{ required: true, message: 'Por favor, complete el nombre de la categoría', }]}>
                                    <Input placeholder="Categoría"/>
                                </Form.Item>
                                :
                                <Form.Item name="field_category" rules={[{ required: true, message: 'Por favor, seleccione una categoría' }]}>
                                    <Select placeholder="Categoría">
                                        {
                                            categoriesOfPromotions && categoriesOfPromotions.map(category => <Option key={category} value={category}>{category}</Option>)
                                        }
                                    </Select>
                                </Form.Item>
                        }
                    </Col>
                </Row>
                <Row center="xs">
                    <Col xs={10} sm={8} md={4}>
                        <Form.Item name="field_type" rules={[{ required: true, message: 'Por favor, complete con un tipo dentro de la categoría', }]}>
                            <Input placeholder="Tipo"/>
                        </Form.Item>
                    </Col>
                </Row>
                <Divider>Icono</Divider>
                <Row center="xs">
                    <Col>
                        <Form.Item name="field_icon" rules={[{ required: true, message: 'Por favor, seleccione un icono para el nuevo ítem'}]}>
                            <Radio.Group name="radiogroup" >
                                {fileIcons && fileIcons.map((icon, index) => <Radio key={index} value={icon.name}><Avatar size={32} src={icon.url} /></Radio>)}
                            </Radio.Group>
                        </Form.Item>
                    </Col>
                </Row>
                <Divider></Divider>
                <Row>
                    <Col xs={1} sm={2} md={4}></Col>
                    <Col xs={5} sm={4} md={2}>
                        <Form.Item>
                            {
                                isSaving ?
                                    <Button type="primary" htmlType="submit" disabled={true} loading>
                                        Guardando
                                    </Button>
                                    :
                                    <Button type="primary" htmlType="submit">
                                        Guardar
                                    </Button>
                            }
                        </Form.Item>
                    </Col>
                    <Col xs={5} sm={4} md={2}>
                        <Form.Item>
                            {
                                <Button disabled={isSaving} onClick={onExitForm}>
                                    Cancelar
                                </Button>
                            }
                        </Form.Item>
                    </Col>
                    <Col xs={1} sm={2} md={4}></Col>
                </Row>
                {
                    isSavedPromotions && onReset()
                }
            </Form>
        </Grid>
    );
};

FormNewPromotion.propTypes = {
    
};

export default FormNewPromotion;